module.exports = {"ADM_DASHBOARD_MAIN_TITLE":"Compañía","ADM_DASHBOARD_SALES_TITLE":"Ventas","ADM_DASHBOARD_ACQUISITION_TITLE":"Adquisición y Retención"}